import ApiService from "../../../ApiService";

const CommentListService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/classcommentlist/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
};

export default CommentListService;
